import React from "react";

// URL patterns we want to clickable-ify:
//   * http(s):// links (with or without www)
//   * bare www.example.com … domains
//   * bare foo.com / foo.co.in style domains with a common TLD
// The regex is deliberately conservative to avoid mangling ordinary punctuation.
const URL_RE = new RegExp(
  "(https?:\\/\\/[^\\s<>()]+" +      // http(s)://…
    "|www\\.[^\\s<>()]+" +             // www.…
    "|\\b[a-zA-Z0-9._-]+\\.(?:com|net|org|io|in|co|gov|edu|app|dev|xyz|me|ai|tech|store|info|health)(?:\\/[^\\s<>()]*)?)",
  "gi"
);

/**
 * linkify(text) — turns any http/https/www/domain-style URL inside a plain
 * text message into a clickable <a> element while leaving the rest of the
 * text untouched. Trailing punctuation (`.`, `,`, `)`, `!`, `?`) is kept
 * outside the anchor so a sentence like `visit rescigo.in.` still renders
 * naturally.
 */
export function linkify(text) {
  if (!text || typeof text !== "string") return text;
  const nodes = [];
  let last = 0;
  let m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text)) !== null) {
    let url = m[0];
    let trailing = "";
    // Strip trailing punctuation so `foo.com.` renders as anchor + '.'
    while (url.length && /[.,)!?;:]$/.test(url)) {
      trailing = url.slice(-1) + trailing;
      url = url.slice(0, -1);
    }
    if (!url) continue;
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    nodes.push(
      <a
        key={`${m.index}-${url}`}
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        className="underline decoration-current/60 hover:decoration-current break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    if (trailing) nodes.push(trailing);
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes.length ? nodes : text;
}
